






import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class OpenModalLink extends Vue {
    @Prop({ required: true }) modalId!: string;

    modalName: string = "";

    isValid = false;

    modal: HTMLElement | null = null;

    mounted() {
        const split1 = this.modalId.split("[popup-");
        if (!split1[1]) {
            return;
        }
        const split2 = split1[1].split("]")[0];
        const modal = document.getElementById(`${split2}`);

        if (!modal) {
            return;
        }

        this.isValid = true;

        this.modal = modal;
    }

    openModal() {
        // @ts-ignore
        this.modal.__vue__.open = true;
    }
}
